import BrandOverviewPlan from './BrandOverviewPlan.Container';

export default BrandOverviewPlan;
